import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import { Input } from "semantic-ui-react";
import { screenIsWiderThan } from "@components/utils";
import { Breakpoints } from "@components/Media";

export class SearchBarILS extends Component {
  inputRef = createRef();

  state = { currentValue: "" };

  componentDidMount() {
    const { focusOnRender } = this.props;
    const autofocus = screenIsWiderThan(Breakpoints.computer);
    if (focusOnRender && autofocus) {
      this.inputRef.current.focus();
    }
  }

  clearQueryString = () => {
    this.setState({ currentValue: "" });
  };

  normalizeQuery = (value) => {
    // Trim ends and collapse multiple spaces
    return value.replace(/\s+/g, " ").trim();
  };

  onKeyPressHandler = (event) => {
    if (event.key === "Enter") {
      const { onSearchHandler } = this.props;
      onSearchHandler(this.normalizeQuery(this.state.currentValue));
    }
  };

  onPasteHandler = (event) => {
    const { onSearchHandler } = this.props;
    event.preventDefault();
    const queryString = (event.clipboardData || window.clipboardData).getData(
      "text"
    );
    const normalized = this.normalizeQuery(queryString);
    this.setState({ currentValue: normalized });
    onSearchHandler(normalized);
  };

  render() {
    const {
      className: parentClass,
      onKeyPressHandler: parentKeyPressHandler,
      onSearchHandler,
      onPasteHandler,
      onChangeHandler,
      placeholder,
      focusOnRender,
      ...rest
    } = this.props;
    const { currentValue } = this.state;
    return (
      <Input
        action={{
          icon: "search",
          onClick: () =>
            onSearchHandler(this.normalizeQuery(this.state.currentValue)),
        }}
        onChange={(event, { value }) => {
          this.setState({ currentValue: value });
          onChangeHandler && onChangeHandler(value);
        }}
        value={currentValue}
        onKeyPress={parentKeyPressHandler || this.onKeyPressHandler}
        onPaste={onPasteHandler || this.onPasteHandler}
        fluid
        size="big"
        placeholder={placeholder}
        className={`${parentClass} ils-searchbar`}
        ref={this.inputRef}
        {...rest}
      />
    );
  }
}

SearchBarILS.propTypes = {
  onKeyPressHandler: PropTypes.func,
  onPasteHandler: PropTypes.func,
  onSearchHandler: PropTypes.func.isRequired,
  onChangeHandler: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  focusOnRender: PropTypes.bool,
};

SearchBarILS.defaultProps = {
  onKeyPressHandler: null,
  onPasteHandler: null,
  onChangeHandler: null,
  placeholder: "",
  className: "",
  focusOnRender: true,
};
